<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Modification par journée
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 style="color: #546E7A"
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " erreur" | pluralize(errors.length) }}
            pour {{ this.$refs.hotTable.hotInstance.getData().length }} {{
              "action"|pluralize(this.$refs.hotTable.hotInstance.getData().length)
            }}.
            Merci de corriger les actions rejetées ci-dessous.
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Matricule (" + error.datas.userId + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-btn @click="handleClick" block class="custom-btn white--text" color="#00BCD4" height="45px"
                     :disabled="disableMainBtn"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span>Vider table</span>
              </v-btn>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn @click="execution" block class="custom-btn white--text" color="#03A9F4" height="45px" large
                     :disabled="disableMainBtn">
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span>Exécution</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import Handsontable from "handsontable";

function cellProblemRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);

  td.className = "colProblem";
}

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 1) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("Brigades"));
  }
}

function customDropDownRender2(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 3) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("Shifts"));
  }
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "modifsProvisoires",
  components: {HotTable},

  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      shifts: [],
      shiftsFull: [],
      lastHighlitedRow: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      toObject: [],
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      editedIndex: -1,
      errors: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [[null, null, null, null, null, null, null]],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ['row_above', 'row_below', 'remove_row'],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        manualColumnResize: true,
        comment: true,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterRemoveRow: this.afterRemoveRowMe,
        currentRowClassName: 'rowHighlight',
        className: "htCenter htMiddle",
        colHeaders:
            ["Matricule", "Nouvelle brigade", "Date Shift", "Nom Shift", "A Supprimer", "A Ajouter", "Observations"],
        columns: [
          {title: "Matricule", width: "150px"},
          {
            title: "Nouvelle brigade",
            width: "160px",
            type: "dropdown",
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {
            title: "Date Shift",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {
            title: "Nom Shift",
            width: "160px",
            type: "dropdown",
            renderer: customDropDownRender2,
            allowInvalid: false,
            strict: true
          },
          {title: "A Supprimer", width: "120px", type: "checkbox"},
          {title: "A Ajouter", width: "120px", type: "checkbox"},
          {title: "Observations", width: "180px"},
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};

          if (col === 6) {
            if (this.instance.getSourceDataAtCell(row, 4) === true) {
              cellProperties.readOnly = true;

              let val = this.instance.getSourceDataAtCell(row, 6)

              if (!(!val || /^\s*$/.test(val))) {
                cellProperties.renderer = cellProblemRenderer;
              }
            } else {
              cellProperties.readOnly = false;
            }
          }

          return cellProperties;
        }
      }
    }
  },

  created() {
    this.populateHot()
    this.isprovisionalModifsExecution()
  },

  methods: {
    populateHot() {
      let v = sessionStorage['dataMProv']
      if ((v !== null) && (v !== undefined) && (v !== "null") && (v !== "[]")) {
        this.hotSettings.data = JSON.parse(sessionStorage['dataMProv'])
      } else {
        this.hotSettings.data = [[null, null, null, null, null, null, null]]
        sessionStorage['dataMProv'] = JSON.stringify([[null, null, null, null, null, null, null]]);
      }

      this.loadShifts()
    },
    isprovisionalModifsExecution() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/isprovisionalmodifsexecution/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }
          })
          .catch(() => {
          });
    },
    loadShifts() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/shifts/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("Shifts", null)
            let datas = response.data.datas;
            this.shiftsFull = datas;
            this.shifts = []
            datas.forEach(item => {
              this.shifts.push(item.shiftName);
            });
            sessionStorage.setItem("Shifts", JSON.stringify(this.shifts))
          })
          .catch(() => {
          });
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    first(p) {
      for (let i in p) return p[i];
    },

    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },

    LineIsValid() {
      let newObj = this.$refs.hotTable.hotInstance.getData()

      let sdate
      let item, index

      for (index = 0; index < newObj.length; ++index) {
        item = newObj[index]

        if (!item[0] || 0 === item[0].length || /^\s*$/.test(item[0])) {
          this.text = "Ligne " + ((index + 1)) + " -> Le matricule n'est pas correct."
          this.showAlert('warning')
          return false
        }

        if (!item[1] || 0 === item[1].length || /^\s*$/.test(item[1])) {
          this.text = "Ligne " + ((index + 1)) + " -> Saisissez la nouvelle brigade d'affectation sinon choisissez HORS-BRIGADES."
          this.showAlert('warning')
          return false
        }

        /*if (this.first (newObj) === item){
            userId = item[0]
            sd = item[1]
            st = item[2]
        }
        else{
            if (userId === item[0] && sd === item[1] && st === item[2]){
                this.text = "Ligne " + (index+1) + " -> Il n'est pas permis de saisir des doublons (Matricule, Shift)."
                this.showAlert('warning')
                return false

            }
        }*/

        if (!item[2] || 0 === item[2].length || /^\s*$/.test(item[2])) {
          this.text = "Ligne " + (index + 1) + " -> La date n'est pas renseignée."
          this.showAlert('warning')
          return false
        }

        if (this.isEmpty(item[3])) {
          this.text = "Ligne " + (index + 1) + " -> Choisissez le nom de SHIFT."
          this.showAlert('warning')
          return false
        }

        sdate = moment(item[2], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
        if (sdate === "Invalid date") {
          this.text = "Date & Heure invalide -> Ligne " + (index + 1) + "."
          this.showAlert('warning')
          return false
        }

        if (((item[4] === false) || (item[4] === null)) && ((item[5] === false) || (item[5] === null))) {
          this.text = "Ligne " + (index + 1) + " -> Choisissez une action ('Supprimer' ou 'Ajouter')."
          this.showAlert('warning')
          return false
        }

        if (item[4] === true && item[5] === true) {
          this.text = "Ligne " + (index + 1) + " -> Il n'est pas possible de choisir 2 actions simultanées."
          this.showAlert('warning')
          return false
        }
      }

      return true;
    },

    afterChangeMe: function (changes, source) {
      if (source !== "loadData") {
        // save all data to local storage if the edit happends
        sessionStorage['dataMProv'] = JSON.stringify(this.$refs.hotTable.hotInstance.getData());
      }
    },

    beforeRemoveRowMe(index, amount) {
      if (this.hotSettings.data.length === 1) {
        sessionStorage['dataMProv'] = JSON.stringify([[null, null, null, null, null, null, null]])
        this.hotSettings.data = [[null, null, null, null, null, null, null]]
      }
    },

    afterRemoveRowMe(index, amount) {
      // save all data to local storage if the edit happends
      sessionStorage['dataMProv'] = JSON.stringify(this.$refs.hotTable.hotInstance.getData())
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    onCancel() {
      this.loading = false
    },

    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },

    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },

    close() {
      this.dialog = false;
    },

    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },

    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },

    handleClick() {
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez le vidage de la table.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            sessionStorage['dataMProv'] = JSON.stringify([[null, null, null, null, null, null, null]])
            this.hotSettings.data = [[null, null, null, null, null, null, null]]
            this.$refs.hotTable.hotInstance.loadData(null)
            dialog.close();
          })
          .catch(() => {

          });
    },
    getDayFr(date) {
      if (!date) return null

      const [day, month, year] = date.split('-')
      return `${day}`
    },
    getMonthFr(date) {
      if (!date) return null

      const [day, month, year] = date.split('-')
      return `${month}`
    },
    getYearFr(date) {
      if (!date) return null

      const [day, month, year] = date.split('-')
      return `${year}`
    },
    execution() { // On Click Excel download button
      let vm = this;
      vm.loading = true

      if (!vm.LineIsValid()) {
        vm.loading = false
      } else {
        let userId, brigade, shiftName
        let stimeS, sectimeS, stimeE, sectimeE
        let day, month, year
        let sdate, edate
        let stimeStr, etimeStr
        let dataTosave = []
        let errorTmp = false
        let sDatetimeS, sDatetimeE

        var dateFormat = require('dateformat');
        var oneDayInMilliseconds = 86400000;

        let newObj = vm.hotSettings.data

        newObj.forEach((item) => {
          userId = item[0]
          brigade = item[1]
          shiftName = item[3]

          let ind = 0
          this.shifts.forEach(item => {
            if (item === shiftName) {
              stimeStr = this.shiftsFull[ind].startTime;
              etimeStr = this.shiftsFull[ind].endTime;
            }
            ++ind
          });

          stimeS = stimeStr.split(':');
          sectimeS = parseInt(stimeS[0] * 3600 + stimeS[1] * 60 + stimeS[0]);

          stimeE = etimeStr.split(':');
          sectimeE = parseInt(stimeE[0] * 3600 + stimeE[1] * 60 + stimeE[0]);

          sdate = moment(item[2], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")

          stimeStr = moment(stimeStr, "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")
          etimeStr = moment(etimeStr, "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")

          if (sectimeS <= sectimeE) {
            edate = sdate
          } else {
            //let dayTmp = dateFormat(item[2], "mm-dd-yyyy");
            let dayTmp = item[2];
            day = this.getDayFr(dayTmp)
            month = this.getMonthFr(dayTmp)
            year = this.getYearFr(dayTmp)

            sDatetimeS = new Date(year, month - 1, day)
            sDatetimeE = new Date(sDatetimeS.getTime() + oneDayInMilliseconds)
            //let edateTmp = dateFormat(sDatetimeE, "yyyy-mm-dd");
            edate = moment(sDatetimeE).format("YYYY-MM-DD HH:mm:ss")
          }

          dataTosave.push({
            userId: userId.trim(),
            brigade: brigade.trim(),
            shiftName: shiftName.trim(),
            startDate: sdate,
            startTime: stimeStr,
            endDate: edate,
            endTime: etimeStr,
            bRemove: item[4],
            bAdd: item[5],
            observations: item[6],
            originUser: sessionStorage.getItem("userId")
          });
        });

        apiClient
            .post(
                `${vm.$store.getters.user.baseUrl}/account/modifsprovisoires/` +
                sessionStorage.getItem("userId"),
                dataTosave
            )
            .then(res => {
              vm.loading = false

              if (res.data.status === 200) {
                let dataObj = [];
                let dataError = []
                for (let i = 0; i < res.data.datas.length; i++) {
                  if (res.data.datas[i].status === 200) {
                    dataObj.push(res.data.datas[i].datas);
                  } else {
                    dataError.push(res.data.datas[i]);
                    errorTmp = true;
                  }
                }

                if (dataObj.length > 0 && dataError.length === 0) {
                  vm.loading = false
                  vm.color = "#009688"
                  vm.text = dataObj.length + " action(s) réalisée(s) avec succès.";
                  vm.showAlert('info')
                } else if (dataObj.length === 0 && dataError.length > 0) {
                  vm.loading = false
                  vm.alert = true
                  vm.color = "#F44336"
                  vm.errors = dataError
                  errorTmp = true;
                } else if (dataObj.length > 0 && dataError.length > 0) {
                  vm.loading = false
                  vm.color = "#F44336"
                  vm.errors = dataError
                  vm.alert = true
                  errorTmp = true;
                }
              } else {
                vm.loading = false
                vm.alert = true
                vm.text = res.data.message;
                vm.color = "#F44336"
                vm.showAlert('warning')
                errorTmp = true;
              }
            })
            .catch(err => {
              vm.loading = false
              vm.alert = true
              vm.text = err;
              vm.color = "#F44336"
              vm.showAlert('warning')
            });
      }
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.pre-formatted {
  white-space: pre;
}

.custom-btn {
  width: 200px;
  min-width: 200px;
}

.colProblem {
  text-align: center;
  background-color: yellow !important;
  font-weight: bold !important;
  font-style: normal !important;
}
</style>

